import { Routes, Route } from 'react-router-dom';
import loadable from '@loadable/component';
import AuthProvider from '../../providers/auth.provider';
import { config } from '../../config';
import CheckCMSNewVersionLayer from '../../components/layout/CheckCMSNewVersionLayer';

const liffId = config.liff_id.eclaim;

const ClaimPDPA = loadable(() => import('./ClaimPDPA'), { fallback: null });

const ClaimList = loadable(() => import('./ClaimList'), { fallback: null });

const ClaimForm = loadable(() => import('./ClaimForm'), { fallback: null });

const ClaimTC = loadable(() => import('./ClaimTC'), { fallback: null });

const ClaimComplete = loadable(() => import('./ClaimComplete'), {
  fallback: null,
});

const ClaimReject = loadable(() => import('./ClaimReject'), { fallback: null });

const NotFound = loadable(() => import('../NotFound'), { fallback: null });

export default function EclaimRoute() {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <AuthProvider liffId={liffId}>
            <CheckCMSNewVersionLayer>
              <ClaimPDPA />
            </CheckCMSNewVersionLayer>
          </AuthProvider>
        }
      />
      {/* <Route path="/" element={<ClaimPDPA />} /> */}
      <Route path="mainpage" element={<ClaimList />} />
      <Route path="form" element={<ClaimForm />} />
      <Route path="tc" element={<ClaimTC />} />
      <Route path="complete" element={<ClaimComplete />} />
      <Route path="reject" element={<ClaimReject />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
